import React, {useEffect, useMemo, useState} from 'react';
import useKnowledgeTest, {KnowledgeTestType} from '../../../hooks/apis/useKnowledgeTest';
import {Breadcrumb, Button, Card, Checkbox, Col, Divider, Row, Skeleton} from 'antd';
import Flex from '../../../components/Flex';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import QuickRouter from '../../../utils/QuickRouter';
import Paragraph from 'antd/lib/typography/Paragraph';
import useKnowledgeSubmission from '../../../hooks/apis/useKnowledgeSubmission';
import QRCode from 'qrcode.react';
import useAuth from '../../../utils/AuthContext';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import {useParams} from 'react-router-dom';
import {useMount} from 'react-use';
import useQuickRouter from '../../../utils/QuickRouter';

export default function KnowledgeTestHistoryPage() {
  const auth = useAuth();
  const queryByIdState = useKnowledgeTest.queryById();
  const queryHistory = useKnowledgeTest.queryHistoryByTestId();
  const queryHistoryList = useKnowledgeTest.queryHistory();
  const params = useParams() as {id?: string; userId?: string};
  const testId = parseInt(params?.id || '');
  const test = queryByIdState.data;
  const history = queryHistory.data;
  const routeQueryUserId = params?.userId || '';
  const quickRouter = useQuickRouter();

  function refresh() {
    console.log(params);
    queryByIdState
      .request({id: testId})
      .then(() => {
        queryHistory
          .request({testId, userId: parseInt(routeQueryUserId)})
          .then(() => {
            queryHistoryList.request({testId}).catch(CommonApiErrorHandler);
          })
          .catch(CommonApiErrorHandler);
      })
      .catch(CommonApiErrorHandler);
  }

  useMount(() => {
    refresh();
  });

  const result = useMemo(() => {
    const result = {
      isFound: false,
      count: 0,
      totalScoreGet: 0,
      averageScoreGet: 0,
      bestScoreGet: 0,
      totalRecordCount: 0,
      countRank: 0,
      totalScoreGetRank: 0,
      averageScoreGetRank: 0,
      bestScoreGetRank: 0,
    };
    const history = queryHistory.data;
    const historyList = queryHistoryList.data;
    if (!history || !historyList) return result;
    result.isFound = true;
    result.count = history.count;
    result.totalScoreGet = history.totalScoreGet;
    result.averageScoreGet = history.averageScoreGet;
    result.bestScoreGet = history.bestScoreGet;
    result.totalRecordCount = historyList.length;

    historyList.sort((a, b) => a.count - b.count);
    result.countRank = historyList.findIndex(i => i.submitter.id === history.submitter.id) + 1;

    historyList.sort((a, b) => a.totalScoreGet - b.totalScoreGet);
    result.totalScoreGetRank = historyList.findIndex(i => i.submitter.id === history.submitter.id) + 1;

    historyList.sort((a, b) => a.averageScoreGet - b.averageScoreGet);
    result.averageScoreGetRank = historyList.findIndex(i => i.submitter.id === history.submitter.id) + 1;

    historyList.sort((a, b) => a.bestScoreGet - b.bestScoreGet);
    result.bestScoreGetRank = historyList.findIndex(i => i.submitter.id === history.submitter.id) + 1;

    return result;
  }, [queryByIdState.data, queryHistoryList.data, queryHistory.data]);

  return (
    <Flex justify={'center'}>
      <div style={{width: 700}}>
        <Breadcrumb className={'mb-md'}>
          <Breadcrumb.Item>
            <a onClick={quickRouter.index}>首页</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => quickRouter.contestDetail(test?.contest?.id || 0)}>活动首页</a>
          </Breadcrumb.Item>
        </Breadcrumb>
        <Card style={{width: 700}}>
          <Skeleton loading={queryByIdState.loading}>
            {!result.isFound && <div>未查询到成绩</div>}
            {test && history && result.isFound && (
              <Flex direction={'column'} align={'center'}>
                <Title level={4}>{test.contest.name}</Title>
                <Title level={2} style={{marginBottom: 15, marginTop: 0}}>
                  {KnowledgeTestType[test.type]} 历史统计
                </Title>
                <Divider />
                <Flex>
                  <Flex align={'center'} justify={'center'} style={{marginRight: 30}}>
                    <img src={'/images/graduation.svg'} alt={'graduation'} style={{width: 150}} />
                  </Flex>
                  <div style={{textAlign: 'left', width: '100%', padding: '0 20px'}}>
                    <Paragraph strong>{history.submitter.legalName} 同学：</Paragraph>
                    <Paragraph>
                      完成 {result.count} 次答题演练，在全体用户中排第 {result.countRank} 名 / 共 {result.totalRecordCount} 名；
                    </Paragraph>
                    <Paragraph>
                      总成绩为 {result.totalScoreGet} 分，在全体用户中排第 {result.totalScoreGetRank} 名 / 共 {result.totalRecordCount} 名；
                    </Paragraph>
                    <Paragraph>
                      平均分为 {result.averageScoreGet} 分，在全体用户中排第 {result.averageScoreGetRank} 名 / 共 {result.totalRecordCount} 名；
                    </Paragraph>
                    <Paragraph>
                      单次最高分为 {result.bestScoreGet} 分，在全体用户中排第 {result.bestScoreGetRank} 名 / 共 {result.totalRecordCount} 名。
                    </Paragraph>
                  </div>
                </Flex>
                <div style={{textAlign: 'center', marginTop: 20, width: '100%'}}>
                  <QRCode size={80} value={window.location.href} />
                </div>
              </Flex>
            )}
          </Skeleton>
        </Card>
      </div>
    </Flex>
  );
}
